import React, { useEffect,useState } from 'react'
import Axios from 'axios'
import { useForm } from "react-hook-form";
import 'react-multiple-select-dropdown-lite/dist/index.css'
import BadgeIcon from '@mui/icons-material/Badge';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import EmailIcon from '@mui/icons-material/Email';
import './CRM.css'
const Swal = require('sweetalert2');

export const CRMEdit = () => {
useEffect(() => {
    const token = localStorage.getItem('token')
    fetch('http://27.254.66.164:5000/Author',{
    method: 'POST',
    mode: 'cors',
    headers: {
        'Authorization': 'Bearer '+token,
        'Content-Type': 'application/json',
    },
})
.then(response => response.json())
.then(data => {
        if (data.status === 'ok'){
        } else {
          Swal.fire({
            title: 'กรุณาเข้าสู่ระบบอีกครั้ง',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'ตกลง',
          }).then((result) => {
            if (result.isConfirmed) { 
              window.location.href = '/ec-crm/Login'
            }
          })
        }
    });
})
const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const CustomerId = urlParams.get('CustomerId');
 const { register, handleSubmit } = useForm({});
 const [CustomerList, setCustomerList] = useState([]);
 const [CustomerName, setName] = useState(""); 
 const [Phone, setPhone] = useState("");
 const [Email, setEmail] = useState("");
 const [LineID, setLineID] = useState("");

 var CryptoJS = require("crypto-js/core");
 CryptoJS.AES = require("crypto-js/aes");
 var secret = "Ec";
 
 useEffect(()=> {
    const fetch = async () => {
          try {
          Axios.post('http://27.254.66.164:5000/EditCus',{
            CrmCustomerId: CustomerId,
          }).then((response) => {
            setCustomerList(response.data);
          });
        } catch (error) {
            console.error(error)
        }
    }
    fetch()
 },[])
   if(CustomerList!= ""){
    useEffect(() => {
      const CusName = CustomerList.map(person => person.CustomerName).toString();
      const decryptCusName = CryptoJS.AES.decrypt(CusName,secret).toString(CryptoJS.enc.Utf8);
      const CustomerNameE = decryptCusName.substring(1, decryptCusName.length - 1);
      const Phone1 =CustomerList.map(person => person.Phone).toString();;
      const decryptPhone = CryptoJS.AES.decrypt(Phone1,secret).toString(CryptoJS.enc.Utf8);
      const PhoneE = decryptPhone.substring(1, decryptPhone.length - 1);
      const Emaill = CustomerList.map(person => person.Email).toString();;
      const decryptEmail = CryptoJS.AES.decrypt(Emaill,secret).toString(CryptoJS.enc.Utf8);
      const EmailE = decryptEmail.substring(1, decryptEmail.length - 1);
      const Line = CustomerList.map(person => person.LineID).toString();;
      const decryptLine = CryptoJS.AES.decrypt(Line,secret).toString(CryptoJS.enc.Utf8);
      const LineIDE = decryptLine.substring(1, decryptLine.length - 1);
      setLineID(LineIDE);
      setName(CustomerNameE);
      setPhone(PhoneE);
      setEmail(EmailE);
    },[]);
  }else{
    useEffect(() => {
      const CusName = CustomerList.map(person => person.CustomerName).toString();
      const decryptCusName = CryptoJS.AES.decrypt(CusName,secret).toString(CryptoJS.enc.Utf8);
      const CustomerNameE = decryptCusName.substring(1, decryptCusName.length - 1);
      const Phone1 =CustomerList.map(person => person.Phone).toString();;
      const decryptPhone = CryptoJS.AES.decrypt(Phone1,secret).toString(CryptoJS.enc.Utf8);
      const PhoneE = decryptPhone.substring(1, decryptPhone.length - 1);
      const Emaill = CustomerList.map(person => person.Email).toString();;
      const decryptEmail = CryptoJS.AES.decrypt(Emaill,secret).toString(CryptoJS.enc.Utf8);
      const EmailE = decryptEmail.substring(1, decryptEmail.length - 1);
      const Line = CustomerList.map(person => person.LineID).toString();;
      const decryptLine = CryptoJS.AES.decrypt(Line,secret).toString(CryptoJS.enc.Utf8);
      const LineIDE = decryptLine.substring(1, decryptLine.length - 1);
      setLineID(LineIDE);
      setName(CustomerNameE);
      setPhone(PhoneE);
      setEmail(EmailE);
    });
  }
const EditCustomer = () => {
      const EmpId = localStorage.getItem('EmpId')
      Axios.post('http://27.254.66.164:5000/Editform', {  
        CrmCustomerId: CustomerId, 
        CustomerName: CustomerName,
        Phone: Phone,
        Email: Email,
        LineID: LineID,
        EmpId: EmpId
      }).then(() => {
        setCustomerList([
            ...CustomerList,
          {
            CrmCustomerId: CustomerId, 
            CustomerName: CustomerName,
            Phone: Phone,
            Email: Email,
            LineID: LineID,
            EmpId: EmpId
          }
        ])
      });
      Swal.fire({
        title: 'สำเร็จ',
        text: "บันทึกสำเร็จ",
        icon: 'success',
        showConfirmButton: false,
        timer: 1500
      }).then((result) => {
            window.location.href = '/ec-crm/ListCustomer';
      })
}
  return (
    <div className="container">
      <br></br> 
      <h2 align="center">แก้ไขข้อมูลลูกค้า</h2>  
            <br></br>       
            <form  onSubmit={handleSubmit(EditCustomer)} align="center">   
                  <div className="row justify-content-md-center">            
                                      <div className="col col-lg-4" >
                                          <label htmlFor='ProjectId' align="left" className='visually-hidden'>ชื่อ-นามสกุล </label>
                                          <div className="input-group">
                                          <span className="input-group-text"><BadgeIcon /></span>
                                          <input type="text" className='form-control' {...register("CustomerName",{ required: false })}
                                            value={CustomerName} onChange={event => setName(event.target.value)}/>
                                          </div>
                                      </div>  
                                      <div className="col col-lg-4">
                                          <label htmlFor='Phone' className='visually-hidden'>เบอร์โทรศัพท์</label>
                                          <div className="input-group">
                                          <span className="input-group-text"><LocalPhoneIcon /></span>
                                          <input type="text" className='form-control' 
                                          value={Phone} onChange={event => setPhone(event.target.value)}/>
                                          </div>
                                      </div>
                  </div>
                  
                  <br></br>
                    <div className="row justify-content-md-center">  
                                        <div className="col col-lg-4" >
                                          <label htmlFor='Email' className='visually-hidden'>อีเมล</label>
                                          <div className="input-group">
                                            <span className="input-group-text"><EmailIcon /></span>
                                            <input type="text"  className='form-control'
                                            value={Email} onChange={event => setEmail(event.target.value)}/>
                                          </div>
                                        </div>
                                        <div className="col col-lg-4" >
                                          <label htmlFor='LineID' className='visually-hidden'>LineID :</label>
                                          <div className="input-group">
                                            <span className="input-group-text"><img src = {require('./../img/line.png')} width="25" height="25"  alt="logo" /></span>
                                            <input type="text" className='form-control' 
                                            value={LineID} onChange={event => setLineID(event.target.value)}/>
                                          </div>
                                        </div>
                    </div>    
                <br></br>
              <button type='submit' className='btn btn-success'>แก้ไขข้อมูลลูกค้า</button>
            </form>     
    </div>
  );
}

